import { c as _c } from "react/compiler-runtime";
import { FileSelectorModal, FileSelectorModalProps, FileSourceEnum, FileUploaderDropZone } from '@systemeio/file-manager';
import { FieldErrorAndDescription } from '@systemeio/ui';
import { ComponentProps, useRef, useState } from 'react';
import { FileListItem } from 'shared/components/file-list/file-list-item';
interface FileUploaderProps {
  files: {
    id: number;
    name: string;
    path: string;
    filename: string;
  }[];
  source: FileSourceEnum;
  isPreFetching?: boolean;
  error?: string;
  errors?: (string | undefined)[];
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect'];
  onDelete: (file: {
    id: number;
    name: string;
    path: string;
    filename: string;
  }) => void;
}
export const FileUploaderWithListedFiles = t0 => {
  const $ = _c(21);
  const {
    files,
    source,
    isPreFetching,
    error,
    errors,
    onSelect,
    onDelete
  } = t0;
  const [opened, setOpened] = useState(false);
  const uploaderRef = useRef(undefined) as NonNullable<FileSelectorModalProps['fileUploaderModalProps']>['uploaderRef'];
  const fileSelectorRef = useRef(undefined);
  let t1;
  if ($[0] !== errors || $[1] !== files || $[2] !== onDelete) {
    t1 = files.length > 0 && <div className="flex flex-col gap-4">{files.map((item, index) => <div key={`${item.id}-${index}`}><FileListItem file={item} onDelete={() => onDelete(item)} />{errors && <FieldErrorAndDescription error={errors[index]} errorClassName="mt-2" />}</div>)}</div>;
    $[0] = errors;
    $[1] = files;
    $[2] = onDelete;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpened(true);
    };
    t3 = file => {
      setOpened(true);
      setTimeout(() => {
        fileSelectorRef?.current?.setFileUploadModalOpen(true);
        uploaderRef?.current?.setWaitingUploadFiles(prev => [...prev, {
          file
        }]);
      });
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== error || $[7] !== isPreFetching) {
    t4 = <FileUploaderDropZone openNativeWindow={false} isPreFetching={isPreFetching} error={error} onClick={t2} onSelectFile={t3} />;
    $[6] = error;
    $[7] = isPreFetching;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      uploaderRef,
      imageCropperModalProps: {
        imageCropperProps: {
          aspectRatio: NaN
        }
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onSelect) {
    t6 = file_0 => {
      setOpened(false);
      onSelect(file_0);
    };
    $[10] = onSelect;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpened(false);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== opened || $[14] !== source || $[15] !== t6) {
    t8 = <FileSelectorModal opened={opened} uploadingFromSource={source} fileSelectorRef={fileSelectorRef} fileUploaderModalProps={t5} onSelect={t6} onClose={t7} />;
    $[13] = opened;
    $[14] = source;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t4 || $[19] !== t8) {
    t9 = <>{t1}{t4}{t8}</>;
    $[17] = t1;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};